<headerCustom></headerCustom>

<sidebarWrapper></sidebarWrapper>
<div class="main-content">
    <div class="userDashContainer">
        <div class="pageContentWrapper">
            <div class="">
                <div class="pageHeading">
                    <div class="row">
                        <div class="col-12">
                            <div class="headerName">
                                <h3>User History</h3>
                                <app-breadcrumb></app-breadcrumb>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row userDropDownContainer">
                    <label class="col-md-12">Select User</label>
                    <div class="col-md-3">
                        <div class="scoreCompStyle" id="adduserPopContainer" *ngIf="userList && userList.length >0">
                            <div class="cusPad">
                                <select class="form-control" [(ngModel)]="selectedCombinedId" placeholder="Select User"
                                    (ngModelChange)="loadDashboard('beh')">
                                    <option value="Select User">Select User</option>
                                    <ng-container *ngFor="let user of userList; let i = index;">
                                        <option value="{{user.userId}}_{{user.nextPosition}}_{{user.towerId}}">{{user.userName}}
                                        </option>
                                    </ng-container>
                                </select>
                            </div>
                        </div>
                    </div>
                    
                </div>

                <div class="row mt-4" >
                    <div class="col-12" >
                        <ul class="nav nav-tabs mt-80" id="skill_type_selector" *ngIf="isShowGraph" >
                            <li class="nav-item">
                                <a class="nav-link" [ngClass]="{'active': activeTab==='beh'}"
                                    (click)="getUserBehSkillRatingInfo('beh'); activeTab = 'beh'">Behavioral Competencies</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" [ngClass]="{'active': activeTab==='fun'}"
                                    (click)="getUserFunSkillRatingInfo(); activeTab = 'fun'">Functional Competencies</a>
                                
                            </li>
                        </ul>
                        <button #btnUserHistory  *ngIf="funSkillRatingList?.length && activeTab==='fun'" class="btn btn-success float-right form-group newcls" title="User History" data-toggle="modal"
                            data-target="#ratingHistory" >Functional Ratings
                        </button>
                        <button #btnUserHistory  *ngIf="behSkillRatingList?.length  && activeTab==='beh'" class="btn btn-success float-right form-group newcls" title="User History" data-toggle="modal"
                                    data-target="#ratingHistory" > Behavioral Ratings
                        </button>
                        <div class="row mtb35 user-dash" *ngIf="chartDataExist" >
                            <div class="col-6" >
                                <section *ngIf="isShowGraph">
                                    <header class="swot-heading text-center">Competency Development</header>
                                </section>
                                <div class="cc_Scroll">
                                    <div class="canvas_container" [ngStyle]="{ height: canvasContainerHeight }">
                                        <canvas id="skill_development_chart">{{ chart }}</canvas>
                                    </div>
                                </div>
                            
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<!-- Show component -->
<div  class="modal fade" id="ratingHistory" tabindex="-1" role="dialog" aria-labelledby="ratingHistory"
  aria-hidden="true" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 1150px;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">User Rating History</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="addUserButtonTableData" >
            <div class="addUserFormLayout customizeRtsScrollBar addUserFormContainer">
                <table class="table rTsCustomizeTable ratingsTable" *ngIf="dateRanges.length">
                    <thead>
                        <tr>
                            <th>S.No.</th>
                            <th>Skill</th>
                            <th>Target Score</th>
                            <th *ngFor="let dateRange of dateRanges;index as i;">
                                <ng-container *ngIf="dateRange !== 1">
                                    {{ dateRange == 1?"":dateRange }}
                                </ng-container>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="text-center">
                        <ng-container *ngFor="let row of convertedData; let i = index;">
                            <tr>
                                <td>
                                    <div>{{i+1}}</div>
                                </td>
                                <ng-container *ngFor="let cell of row; let j = index;">
                                    <td>
                                        <div>{{cell}}</div>
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-container>

                    </tbody>
                </table>
               
            </div>
        </div>
      </div>

    </div>
  </div>
</div>